var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 12.4444H2.33333C1.90556 12.4444 1.55556 12.0944 1.55556 11.6667V2.33333C1.55556 1.90556 1.90556 1.55556 2.33333 1.55556H6.22222C6.65 1.55556 7 1.20556 7 0.777778C7 0.35 6.65 0 6.22222 0H1.55556C0.692222 0 0 0.7 0 1.55556V12.4444C0 13.3 0.7 14 1.55556 14H12.4444C13.3 14 14 13.3 14 12.4444V7.77778C14 7.35 13.65 7 13.2222 7C12.7944 7 12.4444 7.35 12.4444 7.77778V11.6667C12.4444 12.0944 12.0944 12.4444 11.6667 12.4444ZM8.55556 0.777778C8.55556 1.20556 8.90556 1.55556 9.33333 1.55556H11.3478L4.24667 8.65667C3.94333 8.96 3.94333 9.45 4.24667 9.75333C4.55 10.0567 5.04 10.0567 5.34333 9.75333L12.4444 2.65222V4.66667C12.4444 5.09444 12.7944 5.44444 13.2222 5.44444C13.65 5.44444 14 5.09444 14 4.66667V0H9.33333C8.90556 0 8.55556 0.35 8.55556 0.777778Z",
    fill: "#3D1CAF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/ExternalLink.071d6a434fd0c9d5988fcb4ee4ffebbb.svg";
export { ForwardRef as ReactComponent };